"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFaderTimer = void 0;
var react_1 = require("react");
var useFaderTimer = function (_a) {
    var children = _a.children, itemsToShow = _a.itemsToShow, speed = _a.speed, transitionDuration = _a.transitionDuration;
    var childNodes = children;
    var _b = (0, react_1.useState)(0), startIndex = _b[0], setStartIndex = _b[1];
    var _c = (0, react_1.useState)(0), endIndex = _c[0], setEndIndex = _c[1];
    var _d = (0, react_1.useState)([]), visibleItems = _d[0], setVisibleItems = _d[1];
    var _e = (0, react_1.useState)(true), animation = _e[0], setAnimation = _e[1];
    var _f = (0, react_1.useState)(), clock = _f[0], setClock = _f[1];
    (0, react_1.useEffect)(function () {
        setVisibleItems(childNodes.slice(0, itemsToShow));
    }, [setVisibleItems, childNodes, itemsToShow]);
    (0, react_1.useEffect)(function () {
        setEndIndex(itemsToShow);
    }, [itemsToShow, setEndIndex]);
    var resetClock = (0, react_1.useCallback)(function () {
        if (clock) {
            clearTimeout(clock);
            setClock(undefined);
        }
    }, [clock, setClock]);
    var startClock = (0, react_1.useCallback)(function () {
        if (clock) {
            return clock;
        }
        // need to be explicit about which setTimeout we're using for typescript
        var timeout = window.setTimeout(function () { return __awaiter(void 0, void 0, void 0, function () {
            var newStartIndex, newEndIndex;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (startIndex + itemsToShow >= childNodes.length) {
                            newStartIndex = 0;
                            newEndIndex = itemsToShow;
                        }
                        else {
                            newStartIndex = startIndex + itemsToShow;
                            newEndIndex = endIndex + itemsToShow;
                        }
                        setStartIndex(newStartIndex);
                        setEndIndex(newEndIndex);
                        setAnimation(false);
                        return [4 /*yield*/, new Promise(function (r) { return setTimeout(r, transitionDuration); })];
                    case 1:
                        _a.sent();
                        setVisibleItems(childNodes.slice(newStartIndex, newEndIndex));
                        setAnimation(true);
                        startClock();
                        return [2 /*return*/];
                }
            });
        }); }, speed);
        setClock(timeout);
        return timeout;
    }, [
        clock,
        childNodes,
        endIndex,
        itemsToShow,
        speed,
        startIndex,
        setClock,
        setStartIndex,
        setEndIndex,
        setVisibleItems,
        setAnimation,
        transitionDuration,
    ]);
    (0, react_1.useEffect)(function () {
        if (speed) {
            startClock();
        }
        return function () {
            resetClock();
        };
    }, [startClock, resetClock, speed]);
    return { visibleItems: visibleItems, animation: animation };
};
exports.useFaderTimer = useFaderTimer;
